import React, { ReactNode } from 'react';
import { DesktopFiltersBox } from './TopicFilters.styles';

interface IDesktopFiltersContainerProps {
  children: ReactNode;
  filterCount: number;
}

const DesktopFiltersContainer: React.FC<IDesktopFiltersContainerProps> = (
  props
) => {
  const { children } = props;

  return (
    <DesktopFiltersBox
      backgroundColor="white"
      display="flex"
      alignItems="center"
      flexDirection="row"
      paddingLeft="2em"
      flexWrap="nowrap"
      id="opus-topic-filter-bar"
      data-pw="filter-wrapper"
      height="80px"
    >
      {children}
    </DesktopFiltersBox>
  );
};

export default DesktopFiltersContainer;
